import { createFileRoute } from "@tanstack/react-router";
import { FileSignature } from "lucide-react";
import { DashboardShell } from "@/components/DashboardShell";
import { PARTNER_NAV } from "@/lib/nav";
import { SERVICES, SERVICE_AGREEMENTS, isServiceLive, useMyServices } from "@/lib/services";

export const Route = createFileRoute("/_authenticated/partner/agreements")({
  head: () => ({
    meta: [
      { title: "Agreements · Landoo Partner" },
      {
        name: "description",
        content: "Service-specific partner agreements for Sale, Rent, Lease and Parking.",
      },
    ],
  }),
  component: AgreementsPage,
});

function AgreementsPage() {
  const { profiles } = useMyServices();

  return (
    <DashboardShell title="Agreements" role="Partner" items={PARTNER_NAV}>
      <p className="text-sm text-muted-foreground">
        You sign only the agreements for the services you activate. Activating another service later
        requires signing that service's agreement separately.
      </p>

      {SERVICES.map((s) => {
        const profile = profiles.find((p) => p.service_type === s.value);
        const live = profile ? isServiceLive(profile) : false;
        return (
          <div key={s.value} className="mt-5">
            <div className="flex items-center gap-2">
              <h2 className="text-base font-bold text-brown-dark">{s.label} agreements</h2>
              <span className="rounded-full bg-secondary px-2.5 py-1 text-[10px] font-semibold text-muted-foreground">
                {live ? "Service active" : profile ? "Service pending" : "Service not activated"}
              </span>
            </div>
            <div className="mt-2 grid gap-2 sm:grid-cols-2">
              {SERVICE_AGREEMENTS[s.value].map((a) => {
                const signed =
                  profile?.agreement_id === a && profile?.agreement_status === "signed";
                return (
                  <div
                    key={a}
                    className="flex items-center justify-between rounded-2xl border border-border bg-card p-4 shadow-soft"
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-soft text-brown-dark">
                        <FileSignature className="h-4 w-4" />
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-brown-dark">{a}</div>
                        <div className="text-[11px] text-muted-foreground">
                          Version 1.0 ·{" "}
                          {signed
                            ? "Signed"
                            : profile
                              ? "Not signed"
                              : "Requires service activation"}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </DashboardShell>
  );
}
